//automaticky udala z property two-way reaktivni.
//pouziti je naslednovne:
//
// 1) Property je nutne oznacit jako reactive: true.
// 2) Je nutne vytvorit data polozku, ktera se jmenuje stejne jako property s postfixem Internal. Ta bude inicializovana z property a bude vyuzivana v komponente.
// 3) Done.
export function AssignReactivePropWatches(component) {
    Object.entries(component.$options.props).forEach(([name, prop]) => {
        if (prop.reactive === true) {
            var internalName = name + "Internal";
            component.$watch(name, function(newValue) {
                component[internalName] = newValue;
            });
            component.$watch(internalName, function(newValue) {
                component.$emit("update:" + name, newValue);
            });
        }
    });
}

//Slouží k použití v js souborech, které nepouživají vue mixiny přijde mi to jako lepší možnost, než si posílat do knihovny celou komponentu.
export function moduleUrl(append) {
    var urlSegments = window.location.pathname
        .split("/")
        .slice(1, 3)
        .join("/");
    var url = [window.location.protocol, "//", window.location.host, "/", urlSegments, "/", append].join("");
    return url;
}

export function textSnippet(value, textLength) {
    return value.length > textLength ? value.substring(0, textLength - 3) + "..." : value;
}

export function originUrl(append) {
    var url = [window.location.origin, "/", append].join("");
    return url;
}

export function getValueFromPath(object, path, separator = ".") {
    let tmp = object;

    const steps = path.split(separator);
    for (let step of steps) tmp = tmp[step];

    return tmp;
}

export function convertArrayOfObjectsToArrayOfValues(array, selector) {
    return array.map(i => i[selector]);
}

export function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}

/**
 * Vytvoří debounced verzi funkce, která se spustí až po uplynutí zadaného zpoždění od posledního zavolání.
 * @param {Function} fn - Funkce, kterou chceš debouncovat.
 * @param {number} delay - Zpoždění v milisekundách.
 * @returns {Function} Debounced funkce.
 */
export function debounce(fn, delay) {
    let timeout;
    return function (...args) {
        const context = this;
        clearTimeout(timeout);
        timeout = setTimeout(() => fn.apply(context, args), delay);
    };
}

/**
 * Calculate age from Czech birth number (rodné číslo).
 * @param {string} rodneCislo - Birth number, format: YYMMDD or YYMMDD/XXXX.
 * @returns {number|null} - Age in years or null if invalid.
 */
export function getAgeFromRC(rodneCislo) {
    if (!rodneCislo || rodneCislo.length < 6) return null;

    // Remove slash and trim
    const rc = rodneCislo.replace('/', '').trim();
    const yearPart = parseInt(rc.substring(0, 2), 10);
    const monthPart = parseInt(rc.substring(2, 4), 10);
    const dayPart = parseInt(rc.substring(4, 6), 10);

    const currentYear = new Date().getFullYear();
    const fullYear = yearPart + (yearPart > currentYear % 100 ? 1900 : 2000);
    const correctedMonth = monthPart > 50 ? monthPart - 50 : monthPart;

    const birthDate = new Date(fullYear, correctedMonth - 1, dayPart);
    const today = new Date();

    let age = today.getFullYear() - birthDate.getFullYear();
    const m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
        age--;
    }

    return age;
}

/**
 * Provede hlubokou kopii objektu nebo pole.
 * @param {any} obj - Objekt nebo pole ke kopírování.
 * @returns {any} Hluboká kopie objektu.
 */
export function cloneDeep(obj) {
    if (obj === null || typeof obj !== "object") {
        return obj;
    }

    if (obj instanceof Date) {
        return new Date(obj.getTime());
    }

    if (obj instanceof Array) {
        return obj.map(item => cloneDeep(item));
    }

    if (typeof obj === "object") {
        const clonedObj = {};
        for (const key in obj) {
            if (obj.hasOwnProperty(key)) {
                clonedObj[key] = cloneDeep(obj[key]);
            }
        }
        return clonedObj;
    }

    return obj;
}

/**
 * Seřadí pole objektů podle zadané vlastnosti.
 * @param {Array} array - Pole k seřazení.
 * @param {string|Function} iteratee - Vlastnost nebo funkce pro seřazení.
 * @returns {Array} Seřazené pole.
 */
export function sortBy(array, iteratee) {
    if (!Array.isArray(array)) {
        return [];
    }

    return array.slice().sort((a, b) => {
        let aVal, bVal;

        if (typeof iteratee === 'function') {
            aVal = iteratee(a);
            bVal = iteratee(b);
        } else if (typeof iteratee === 'string') {
            aVal = a[iteratee];
            bVal = b[iteratee];
        } else {
            aVal = a;
            bVal = b;
        }

        if (aVal < bVal) return -1;
        if (aVal > bVal) return 1;
        return 0;
    });
}
export function formatDateTime(value) {
    if (!value) return "";

    const date = new Date(value);

    const pad = n => n.toString().padStart(2, "0");

    return (
        pad(date.getDate()) + "." +
        pad(date.getMonth() + 1) + "." +
        date.getFullYear() + " " +
        pad(date.getHours()) + ":" +
        pad(date.getMinutes()) + ":" +
        pad(date.getSeconds())
    );
}
